import { Outlet, useLocation } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import { Box, Paper, Typography, useMediaQuery } from '@mui/material'
import bg from '../../assets/images/blue-bg.jpg'
import home from '../../assets/images/home.png'
import sso from '../../assets/images/sso.svg'
import { PATH_LOGIN } from '../../routes/constant'

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const { pathname } = useLocation()
  const isPasswordCreate = pathname === PATH_LOGIN.PASSWORD_CREATE

  return (
  <Paper sx={{ alignItems: 'stretch', display: 'flex', justifyContent: 'stretch', height: '100vh', position: 'relative' }}>
    <Box
      component='img'
      src={bg}
      sx={{
        display: 'none',
        [theme.breakpoints.up('lg')]: {
          display: 'block',
          width: '50%'
        }
      }}
    />
    {!isMobile && <Box
        component='img'
        src={home}
        sx={{ position: 'absolute', top: '22.35vh', left: '25%', width: '23.97vh', height: '25.7vh', transform: 'translate(-50%, 0)' }}
    />}
    {!isMobile && <Typography sx={{
      position: 'absolute',
      top: isPasswordCreate ? '45.65vh' : '50.65vh',
      left: '25%',
      transform: 'translate(-50%, 0)',
      fontSize: '3.44vw',
      width: '36.82vw',
      textAlign: 'center',
      lineHeight: '101.818%',
      color: '#FFFFFF',
      fontWeight: '800'
    }}>{isPasswordCreate ? 'The Long Awaited Agent Elite 2.0 Is Here!' : 'Agent Elite 2.0 Is Here!'}</Typography>}
    {!isMobile && <Typography sx={{
      position: 'absolute',
      top: isPasswordCreate ? '58.73vh' : '56.73vh',
      left: '25%',
      transform: 'translate(-50%, 0)',
      fontSize: '1.25vw',
      color: '#FFFFFF',
      fontWeight: '700',
      lineHeight: '345%'

    }}>
      {isPasswordCreate ? 'We’re proud to give you more ways to help you close more! ' : 'The more active you are here, the more your business thrives!'}
    </Typography>}
    <Box sx={{
      background: '#fff',
      width: '100%',
      [theme.breakpoints.up('lg')]: {
        width: '50%'
      }
    }}>
      <Box sx={{
        [theme.breakpoints.down('md')]: {
          margin: '100px 25px 0',
          maxWidth: '100%'
        },
        [theme.breakpoints.between('md', 'lg')]: {
          margin: '100px auto 0',
          maxWidth: '60%'
        },
        [theme.breakpoints.only('lg')]: {
          margin: '200px auto 0',
          maxWidth: '400px'
        },
        [theme.breakpoints.up('lg')]: {
          margin: '200px auto 0',
          maxWidth: '511px'
        }
      }}>
        <Outlet />
      </Box>
      <Box
        component='img'
        src={sso}
        sx={{
          bottom: '24px',
          height: '57px',
          position: 'absolute',
          right: '13px',
          width: '57px'
        }}
      />
    </Box>
  </Paper>
  )
}

export default MinimalLayout
